
import React from 'react'
import usePageTitle from '../../hooks/usePageTitle'
import PaidCampaigns from './PaidCampaigns'
import BarterCampaigns from './BarterCampaigns'
import ProCampaigns from './ProCampaigns'
import EarlyAccessCampaigns from './EarlyAccessCampaigns'
import AllCampaigns from './AllCampaigns'
import InvitedCampaignsV2 from '../campaign/InvitedCampaignsV2'
import { useSelector } from 'react-redux'
import { selectAllCampaigns } from '../../redux-stores/selectors/campaignSelectors'
import { RootState } from '../../redux-stores/store'

const AllSponsorships = () => {
    usePageTitle('Sponsorships')
    const campaigns = useSelector(selectAllCampaigns);
    const loading = useSelector((state: RootState) => state.campaigns.loading);
    const invitedCampaigns = useSelector((state: RootState) => state.campaigns.invited.list);
    const invitedLoading = useSelector((state: RootState) => state.campaigns.invited.loading);

    return (
        <div className="mt-3 d-flex flex-column gap-4">
            <InvitedCampaignsV2 />
            <PaidCampaigns />
            <BarterCampaigns />
            <ProCampaigns />
            {/* <EarlyAccessCampaigns /> */}
            <AllCampaigns />
            {
                (!invitedLoading && !loading && invitedCampaigns.length === 0 && campaigns.length === 0) && (
                    <div className="empty-campaigns-container d-flex flex-column align-items-center justify-content-center py-5 my-5">
                        <h5 className="text-center mb-2" style={{ color: "#888", fontWeight: 600 }}>
                            No campaigns found
                        </h5>
                        <p className="text-center" style={{ color: "#AAA", maxWidth: 320 }}>
                            There are currently no sponsorship opportunities matching your profile.
                            Please check back soon or adjust your filters.
                        </p>
                    </div>
              
                )
            }
        </div>
    )
}

export default AllSponsorships